module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyright2"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("Text copyright © 2017 Diane Zahler")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved.")])]), _c('p', {
    staticClass: "copyright"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("For information about permission to reproduce selections from this book, contact ")]), _c('a', {
    attrs: {
      "href": "mailto:permissions@highlights.com"
    }
  }, [_vm._v("permissions@highlights.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("This is a work of fiction. Names, characters, places, and incidents are products of the author’s imagination or are used fictitiously. Any resemblance to actual events, locales, or persons, living or dead, is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Boyds Mills Press")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("An Imprint of Highlights")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("815 Church Street")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Honesdale, Pennsylvania 18431")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-1-62979-724-3 (hc)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("ISBN: 978-1-62979-918-6 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Library of Congress Control Number: 2017937875")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("First edition")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("The text of this book is set in Bembo.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Design by Tim Gillner")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("H1.0")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39176f7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/002_Copyright.vue
// module id = 60
// module chunks = 0